import React, {useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {Col, Container, Row} from 'react-bootstrap';
import {useSidebar} from '../../shared/context/SidebarContext';
import {StatisticsProvider, useChartConfig, useStatisticsUI} from './context/StatisticsContext';
import TimeRangeSelector from './components/TimeRangeSelector';
import DeviceTreeContent from './components/sidebar/DeviceTreeContent';
import TimeSeriesChart from './components/charts/TimeSeriesChart';
import AggregatedLogsChart from './components/charts/AggregatedLogsChart';
import './styles/statistics.css';
import './styles/statsSidebar.css';

/**
 * Main Statistics Page Content
 * Renders charts and logs based on time range and active tab
 */
const StatisticsContent = () => {
  const {setContent} = useSidebar();
  const {chartsConfig, loading, error} = useChartConfig();
  const {activeTab, setActiveTab, activeGroup} = useStatisticsUI();

  useEffect(() => {
    if (chartsConfig) {
      setContent(
        <DeviceTreeContent
          chartsConfig={chartsConfig}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
      );
    }
    return () => setContent(null);
  }, [chartsConfig, activeTab, setActiveTab, setContent]);

  const helpLink = activeTab === 'logs'
    ? 'https://lehmannch.atlassian.net/wiki/spaces/SCCKH/pages/771424259/Web+App+SCC-Cloud#Logs'
    : 'https://lehmannch.atlassian.net/wiki/spaces/SCCKH/pages/771424259/Web+App+SCC-Cloud#Statistiken';

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <div>Loading statistics...</div>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="py-5">
        <div className="alert alert-danger" role="alert">
          <strong>Error:</strong> {error.message}
        </div>
      </Container>
    );
  }

  return (
    <div className="statistics-page-wrapper">
      <div className="statistics-main-content">
        <TimeRangeSelector helpLink={helpLink}/>

        {activeTab === 'logs' ? (
          <AggregatedLogsChart/>
        ) : activeGroup ? (
          <Row xs={1} md={2}>
            {activeGroup.charts?.map((chart) => (
              <Col key={chart.name}>
                <TimeSeriesChart chart={chart}/>
              </Col>
            ))}
          </Row>
        ) : null}
      </div>
    </div>
  );
};

/**
 * Statistics Feature Entry Point
 * Wraps content with StatisticsProvider
 */
const Statistics = () => {
  const {eid} = useParams();

  return (
    <StatisticsProvider edgeId={eid}>
      <StatisticsContent/>
    </StatisticsProvider>
  );
};

export default Statistics;

